/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DisplayPrice,
    DisplayPriceFromJSON,
    DisplayPriceFromJSONTyped,
    DisplayPriceToJSON,
} from './';

/**
 * 
 * @export
 * @interface OutBopSummary
 */
export interface OutBopSummary {
    /**
     * 
     * @type {string}
     * @memberof OutBopSummary
     */
    itemId: string;
    /**
     * 
     * @type {string}
     * @memberof OutBopSummary
     */
    itemText: string;
    /**
     * 
     * @type {DisplayPrice}
     * @memberof OutBopSummary
     */
    itemPrice?: DisplayPrice;
    /**
     * 
     * @type {string}
     * @memberof OutBopSummary
     */
    menuId: string;
    /**
     * 
     * @type {string}
     * @memberof OutBopSummary
     */
    menuText: string;
    /**
     * 
     * @type {string}
     * @memberof OutBopSummary
     */
    articleNumber?: string | null;
}

export function OutBopSummaryFromJSON(json: any): OutBopSummary {
    return OutBopSummaryFromJSONTyped(json, false);
}

export function OutBopSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutBopSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'itemId': json['itemId'],
        'itemText': json['itemText'],
        'itemPrice': !exists(json, 'itemPrice') ? undefined : DisplayPriceFromJSON(json['itemPrice']),
        'menuId': json['menuId'],
        'menuText': json['menuText'],
        'articleNumber': !exists(json, 'articleNumber') ? undefined : json['articleNumber'],
    };
}

export function OutBopSummaryToJSON(value?: OutBopSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'itemId': value.itemId,
        'itemText': value.itemText,
        'itemPrice': DisplayPriceToJSON(value.itemPrice),
        'menuId': value.menuId,
        'menuText': value.menuText,
        'articleNumber': value.articleNumber,
    };
}


